import { render } from "./ExploreCanvas.vue?vue&type=template&id=129be820"
import script from "./ExploreCanvas.vue?vue&type=script&lang=js"
export * from "./ExploreCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__